<template>
  <footer class="row kal-footer">
    <div class="medium-12 columns">
      <img
        src="@/assets/images/logo.png"
        alt="logo kalakai"
        class="logo-kalakai"
      />
      <div class="subheader">
        <small>
          &copy; 2019 Beereaders SPA
        </small>
      </div>
      <div class="subheader">
        <small>8 AÑOS DE EXPERIENCIA EN TECNOLOGÍA EDUCATIVA</small>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>
